import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, TextField, Button, IconButton } from "@mui/material";
import { X } from "lucide-react";
export const ExportArticlesDialog = React.memo(({ open, onClose, domainUrl, onDomainUrlChange, onSubmit, loading, error }) => (_jsxs(Dialog, { open: open, onClose: onClose, PaperProps: {
        sx: {
            borderRadius: "16px",
            width: "100%",
            maxWidth: "600px",
            m: 1,
            boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)"
        }
    }, children: [_jsxs(DialogTitle, { className: "all-Font-Sizes-16", sx: { display: "flex", justifyContent: "space-between", alignItems: "center", p: "24px", pb: "8px", color: "#101828" }, children: ["Export Publisher Articles", _jsx(IconButton, { onClick: onClose, size: "small", sx: { color: "#667085", "&:hover": { backgroundColor: "#F9FAFB" } }, children: _jsx(X, { size: 24 }) })] }), _jsx(DialogContent, { sx: { px: "24px", pb: "24px", pt: "8px" }, children: _jsxs(Box, { sx: {
                    border: "1.2px solid #EAECF0",
                    borderRadius: "8px",
                    px: "16px",
                    py: "16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                    backgroundColor: "#fff"
                }, children: [_jsx(Typography, { className: "all-Font-Sizes", sx: { fontSize: "14px", fontWeight: 600, color: "#344054" }, children: "Domain URL" }), _jsx(TextField, { fullWidth: true, placeholder: "Enter URL", value: domainUrl, onChange: (e) => onDomainUrlChange(e.target.value), variant: "standard", InputProps: {
                            disableUnderline: true,
                            sx: {
                                fontSize: "16px",
                                color: "#101828",
                                border: "1.2px solid #D0D5DD",
                                borderRadius: "8px",
                                px: "14px",
                                py: "12px",
                                backgroundColor: "#fff",
                                transition: "all 0.2s",
                                "&:hover": { borderColor: "#ff008e" },
                                "&.Mui-focused": { borderColor: "#ff008e", boxShadow: "0px 0px 0px 4px rgba(255, 0, 142, 0.1)" },
                                "& input::placeholder": {
                                    color: "#667085",
                                    opacity: 1
                                }
                            }
                        } }), error && (_jsx(Typography, { sx: { color: "#d32f2f", fontSize: "12px", mt: 0.5, fontWeight: 500 }, children: error }))] }) }), _jsx(DialogActions, { sx: { pb: "32px", px: "24px", pt: 0 }, children: _jsx(Button, { fullWidth: true, variant: "contained", onClick: onSubmit, disabled: loading || !domainUrl.trim(), sx: {
                    bgcolor: "#ff008e",
                    color: "white",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontSize: "16px",
                    fontWeight: 600,
                    height: "48px",
                    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    "&:hover": {
                        bgcolor: "#e60080",
                        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)"
                    },
                    "&.Mui-disabled": {
                        bgcolor: "#ff008e",
                        opacity: 0.8,
                        color: "white"
                    }
                }, children: loading ? "Submitting..." : "Submit" }) })] })));
